var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.216 0H1.53151C0.685595 0 0 0.688361 0 1.53769V26.3221C0 27.1711 0.685595 27.8594 1.53151 27.8594H14.8206V17.0709H11.2046V12.8664H14.8206V9.76551C14.8206 6.167 17.0096 4.20794 20.2067 4.20794C21.7382 4.20794 23.0543 4.32208 23.4382 4.37355V8.13418L21.2207 8.13535C19.4818 8.13535 19.1454 8.96494 19.1454 10.1822V12.8668H23.2921L22.7522 17.0713H19.1454V27.8594H26.2164C27.0619 27.8594 27.7475 27.1711 27.7475 26.3218V1.53769C27.7475 0.688361 27.0619 0 26.216 0Z",
    fill: "#F0EAE1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcb);
export default __webpack_public_path__ + "static/media/fcb.73306ad801d8b0de7f64e3b66aa08f21.svg";
export { ForwardRef as ReactComponent };